export default __webpack_public_path__ + "static/media/q27_step8.7fd2f832.png";